/**
 * Returns the invocation target's source (i.e., the first object in the `event.composedPath()` path).
 * This is particularly useful when using Shadow DOM, as `event.target` is re-targeted to the
 * first element within the document's `<body>` when the event is triggered from within a Shadow DOM. 
 * 
 * @param event An event instance.
 * @returns The first object in the event's path.
 */
export var getEventSource = function getEventSource(event) {
  return event.composedPath()[0];
};

/**
 * Returns the Shadow Root (if available) or `document.body` node of a given element.
 * 
 * @param el An HTML element instance.
 * @returns The Shadow Root (i.e., `DocumentFragment`) if the element is within a Shadow DOM; otherwise,
 * the `document.body` element.
 */
export var shadowOrDocumentBody = function shadowOrDocumentBody(el) {
  if (!el) return document.body;
  var targetNode = el.getRootNode();
  targetNode = targetNode instanceof DocumentFragment ? targetNode : document.body;
  return targetNode;
};
export var getActiveElement = function getActiveElement(root) {
  if (root === void 0) {
    root = document;
  }
  var activeEl = root.activeElement;
  if (!activeEl) {
    return null;
  }
  if (activeEl.shadowRoot) {
    return getActiveElement(activeEl.shadowRoot);
  } else {
    return activeEl;
  }
};